var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.error.statusCode === 404)?_c('h1',[_vm._v("Pagina niet gevonden")]):_c('h1',[_vm._v("WhatTheOops, er ging iets fout!")]),_vm._v(" "),_c('nuxt-link',{attrs:{"to":"/elektrische-auto"}},[_vm._v("Ga terug naar huis")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }